var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessVerificationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38576",
    "data-name": "Group 38576",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12080",
    "data-name": "Rectangle 12080",
    width: 42,
    height: 42,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38573",
    "data-name": "Group 38573",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23078",
    "data-name": "Path 23078",
    d: "M23.017,29.8a3.736,3.736,0,0,1-2.937-1.39,3.81,3.81,0,0,1-5.428-2.632,3.814,3.814,0,0,1-3.583-4.857,3.815,3.815,0,0,1-.918-5.966,3.818,3.818,0,0,1,1.962-5.71A3.819,3.819,0,0,1,16.506,5.1a3.821,3.821,0,0,1,5.816-1.627,3.82,3.82,0,0,1,5.905,1.264A3.817,3.817,0,0,1,32.866,8.6a3.815,3.815,0,0,1,2.312,5.576,3.812,3.812,0,0,1-.544,6.011,3.81,3.81,0,0,1-3.273,5.068,3.809,3.809,0,0,1-5.252,2.967A3.736,3.736,0,0,1,23.146,29.8l-.128,0m-2.7-3.327a.792.792,0,0,1,.168.018.807.807,0,0,1,.562.445,2.181,2.181,0,0,0,4-.124.808.808,0,0,1,1.238-.346A2.181,2.181,0,0,0,29.768,24.5a.807.807,0,0,1,.936-.88,2.121,2.121,0,0,0,2.18-.963,2.162,2.162,0,0,0-.012-2.4.808.808,0,0,1,.421-1.215,2.116,2.116,0,0,0,1.481-1.862,2.169,2.169,0,0,0-1.124-2.124.807.807,0,0,1-.191-1.269,2.117,2.117,0,0,0,.444-2.337,2.171,2.171,0,0,0-1.982-1.36.808.808,0,0,1-.758-1.035,2.118,2.118,0,0,0-.7-2.277A2.17,2.17,0,0,0,28.082,6.5a.809.809,0,0,1-1.152-.563A2.123,2.123,0,0,0,25.252,4.24a2.169,2.169,0,0,0-2.239.857.808.808,0,0,1-.631.335.793.793,0,0,1-.65-.3,2.191,2.191,0,0,0-3.859,1.08.809.809,0,0,1-1.115.631,2.166,2.166,0,0,0-2.358.43,2.121,2.121,0,0,0-.557,2.319.81.81,0,0,1-.694,1.079,2.166,2.166,0,0,0-1.891,1.48,2.119,2.119,0,0,0,.587,2.308.808.808,0,0,1-.112,1.278,2.169,2.169,0,0,0-.988,2.191A2.114,2.114,0,0,0,12.337,19.7a.808.808,0,0,1,.5,1.185,2.169,2.169,0,0,0,.141,2.4,2.113,2.113,0,0,0,2.232.824.808.808,0,0,1,.99.82A2.161,2.161,0,0,0,17.43,26.98a2.123,2.123,0,0,0,2.364-.309.8.8,0,0,1,.527-.2",
    transform: "translate(-1.75 -0.495)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23079",
    "data-name": "Path 23079",
    d: "M25.388,21.847a.8.8,0,0,1-.571-.237l-3.156-3.156L22.8,17.312l2.475,2.475,4.971-7.1,1.323.926L26.049,21.5a.809.809,0,0,1-.591.342.682.682,0,0,1-.07,0",
    transform: "translate(-4.166 -2.44)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23080",
    "data-name": "Path 23080",
    d: "M28.4,46.333a.861.861,0,0,1-.09,0,.806.806,0,0,1-.669-.528l-2.908-8.045,1.519-.549,2.353,6.508,1.054-1.641a.807.807,0,0,1,.882-.346l2.354.611-3.242-8.413,1.506-.582,3.809,9.88a.808.808,0,0,1-.956,1.073l-3.31-.859-1.622,2.525a.81.81,0,0,1-.68.371",
    transform: "translate(-4.757 -6.412)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23081",
    "data-name": "Path 23081",
    d: "M21.7,46.4a.808.808,0,0,1-.679-.371L19.4,43.508l-3.31.859a.808.808,0,0,1-.956-1.073l3.7-9.586,1.507.581L17.2,42.408l2.354-.611a.805.805,0,0,1,.881.346l1.014,1.577.446-1.388,1.538.494-.968,3.017a.808.808,0,0,1-.664.554.927.927,0,0,1-.105.006",
    transform: "translate(-2.899 -6.482)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23082",
    "data-name": "Path 23082",
    d: "M24.392,25.147a7.909,7.909,0,1,1,0-15.817,7.832,7.832,0,0,1,3.564.846l-.729,1.442a6.227,6.227,0,0,0-2.835-.673,6.284,6.284,0,1,0,6.148,4.944l1.579-.342a7.917,7.917,0,0,1-7.727,9.6",
    transform: "translate(-3.17 -1.794)",
    fill: "#010101"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessVerificationIcon);
export default __webpack_public_path__ + "static/media/business-verification-icon .36080b7d946f455a0d0bdf085e2cf33b.svg";
export { ForwardRef as ReactComponent };